import { business_group } from './api/entities';

export const actions = {
  getBusinessGroupList: 'GET_BUSINESS_GROUPS',
};

export function getBusinessGroupList(query, sort) {
  return business_group.list(actions.getBusinessGroupList, query, sort);
}

const INITIAL_STATE = {
  business_groups: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.getBusinessGroupList:
      return {
        ...state,
        business_groups: action.body ? action.body._items : state.business_groups,
      };
    default:
      return { ...state };
  }
}
